import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Radio from 'components/Input/Radio';

/**
 * Radio with an icon (svg format) and a large click zone with check indicator on top right.
 * @param  {String}         id        identifier of input
 * @param  {String}         name      radio button group name
 * @param  {String}         className ClassName defined on wrapper
 * @param  {ReactComponent} icon      SVG Icon to display above label
 * @param  {String}         label     Label to display
 * @param  {Object}         input     Object from `redux-form` Field component
 * @return {ReactComponent} Component as a label
 */
const IconRadio = ({ id, className, icon, label, input }) => {
    const checked = input.value === id;

    const wrapperClasses = classnames(className, 'radio-rect', {
        'radio-rect--checked': checked,
    });

    const labelClasses = classnames('radio-rect__label', {
        'radio-rect__label--checked': checked,
    });

    return (
        <label className={wrapperClasses} htmlFor={id}>
            {checked ? <span className="icon-done radio-rect__check text--primary" /> : null}
            <span className="radio-rect__info">
                {icon ? React.cloneElement(icon, { checked, className: 'radio-rect__icon' }) : null}
                <span className={labelClasses}>{label}</span>
            </span>
            <Radio id={id} input={input} checked={checked} className="radio-rect__radio" />
        </label>
    );
};

IconRadio.displayName = 'IconRadio';

IconRadio.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    id: PropTypes.string,
    input: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }).isRequired,
    label: PropTypes.string,
};

IconRadio.defaultProps = {
    id: 'icon-radio',
};

export default IconRadio;
